import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { History } from '../../../../_models/History';

@Component({
  selector: 'app-historique-form',
  templateUrl: './historique-form.component.html',
  styleUrls: ['./historique-form.component.scss'],
})
export class HistoriqueFormComponent implements OnInit {
  @Input() whereClauseFields!: {
    fieldDateStart: string;
    fieldDateEnd: string;
  };
  @Input() loading!: boolean;
  @Input() exportLoading!: boolean;
  @Output() applyFilter = new EventEmitter<string>();
  @Output() applyExport = new EventEmitter<History>();

  minimized = false;
  showSlider = false;
  history: History | undefined;
  labelOfSelectedItem: string = '';

  form = new FormGroup({
    recurrence: new FormControl(7, Validators.required),
    step: new FormControl(1, Validators.required),
    recurrenceHourStart: new FormControl('06:00', [
      Validators.required,
      Validators.pattern('^[0-1]{1}[\\d]{1}:[0-5]{1}[\\d]{1}|^2[0-3]{1}:[0-5]{1}[\\d]{1}'),
    ]),
    recurrenceHourEnd: new FormControl('19:00', [
      Validators.required,
      Validators.pattern('^[0-1]{1}[\\d]{1}:[0-5]{1}[\\d]{1}|^2[0-3]{1}:[0-5]{1}[\\d]{1}'),
    ]),
    consultation: new FormGroup(
      {
        start: new FormControl(null, Validators.required),
        end: new FormControl(null, Validators.required),
      },
      Validators.required
    ),
  });

  get consultation() {
    return this.form.get('consultation') as FormGroup;
  }

  constructor() {}

  ngOnInit(): void {}

  formSubmit() {
    this.history = new History(this.form.value, this.whereClauseFields);
    this.showSlider = true;
  }

  select(event: { label: string; whereClause: string }) {
    this.labelOfSelectedItem = event.label;
    this.applyFilter.emit(event.whereClause);
  }

  label(event: string) {
    this.labelOfSelectedItem = event;
  }

  toggleForm() {
    this.showSlider = false;
    this.labelOfSelectedItem = '';
    this.applyFilter.emit('1=1');
  }

  export() {
    this.history = new History(this.form.value, this.whereClauseFields);
    if (this.history) {
      const dates = {
        start: new Date(this.history.consultation.start),
        end: new Date(this.history.consultation.end),
      };
      this.applyExport.emit(this.history);
    }
  }
}
